/**
 * DevExtreme (esm/__internal/grids/grid_core/row_dragging/dom.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import $ from "../../../../core/renderer";
import gridCoreUtils from "../m_utils";
import { CLASSES } from "./const";
const createHandleTemplateFunc = addWidgetPrefix => (container, options) => {
  const $container = $(container);
  if ("data" === options.rowType) {
    $container.addClass(CLASSES.cellFocusDisabled);
    return $("<span>").addClass(addWidgetPrefix(CLASSES.handleIcon));
  }
  gridCoreUtils.setEmptyText($container);
  return;
};
export const GridCoreRowDraggingDom = {
  createHandleTemplateFunc: createHandleTemplateFunc
};